export default "__VITE_ASSET__B3prv6H2__"